// PACKAGES //
import { Link } from "react-router-dom";

// COMPONENTS //
import BrushButton from "../../components/BrushButton";
import Borders from "../../components/Borders";

// IMAGES //
import IMDVLogo from "../../components/IMDVLogo";
import borderTitle from "../../assets/border_title.png";

// STYLES //
import "./styles.css";


export default function Home({ startMusic }) {
    return (
        <div className="home-page">

            <Borders image={borderTitle} scale={0.98} />

                <div className="home-content">
                    <IMDVLogo />

                <div className="home-buttons">

                    <BrushButton
                        // to="/createzombie"
                        to="/warning"
                        onClick={startMusic}
                        className="home-button"
                    >
                        Play Prologue
                    </BrushButton>

                    <BrushButton
                        to="/about"
                        className="home-button"
                    >
                        About
                    </BrushButton>

                </div>

                <p className="credit">©2023-2026 A Planetary Shift</p>

            </div>

        </div>
    );
}